import React, { Component } from "react";
import { Tag } from "antd";
// import ChangePath from "../ServiceApi";

class CardCalendar extends Component {
    constructor(props){
        super(props);
        // const { data } = this.props;
        //console.log('CardCalendar data',data);
        this.state = {
            color : 'blue'
        }
        
        // this.getColor(data.job_category_name)
        //green , yellow , geekblue , gold , purple , pink , cyan , blue
    }

    componentDidMount() {
        const { data } = this.props;
        let m_color = 'blue'
        //console.log(data.job_category_name.toLowerCase());
        if(data.job_category_name !== '' && data.job_category_name !== null){
            if(data.job_category_name.toLowerCase() === 'cleaning'){
                m_color = 'green'
            }else if(data.job_category_name.toLowerCase() === 'monitoring'){
                m_color = 'yellow'
            }else if(data.job_category_name.toLowerCase() === 'photo'){
                m_color = 'geekblue'
            }else if(data.job_category_name.toLowerCase() === 'aqm'){
                m_color = 'gold'
            }else if(data.job_category_name.toLowerCase() === 'present'){
                m_color = 'purple'
            }else if(data.job_category_name.toLowerCase() === 'extra/special'){
                m_color = 'pink'
            }else if(data.job_category_name.toLowerCase() === 'claim suppiler'){
                m_color = 'cyan'
            }else {
                m_color = 'blue'
            }
        }else{
            console.log(data.job_category_name,'job_category_name');
            m_color = 'blue'
        }
        

        this.setState({
            color : m_color
        })
    }

    editJob(data){
        //console.log('editJob : ',data);
        this.props.editPlan(data)
    }

    render() {
        const { data } = this.props;
        const { color } = this.state;
        // let m_color = 'blue'
        // console.log(data.job_category_name.toLowerCase());
        // if(data.job_category_name.toLowerCase() == 'cleaning'){
        //     m_color = 'green'
        // }else if(data.job_category_name.toLowerCase() == 'monitoring'){
        //     m_color = 'yellow'
        // }else if(data.job_category_name.toLowerCase() == 'photo'){
        //     m_color = 'geekblue'
        // }else if(data.job_category_name.toLowerCase() == 'aqm'){
        //     m_color = 'gold'
        // }else if(data.job_category_name.toLowerCase() == 'present'){
        //     m_color = 'purple'
        // }else if(data.job_category_name.toLowerCase() == 'extra/special'){
        //     m_color = 'pink'
        // }else if(data.job_category_name.toLowerCase() == 'claim suppiler'){
        //     m_color = 'cyan'
        // }else {
        //     m_color = 'blue'
        // }
        // console.log('m_color',m_color);
        // this.setState({
        //     color : m_color
        // })
        // console.log(data);
        let m_title = ''
        if(data.asset_code !== null){
            //m_title = data.asset_code     
            m_title = data.plan_name 
        }else{
            //m_title = "Asset List (ID:"+data.emp_service_pm_id+")"
            m_title = data.plan_name
        }

        return (
            <div className="card-planning-list" >
                <div className="d-block" 
                onClick={() => { this.editJob(data) }} 
                >
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <Tag color={color}>{data.job_category_name}</Tag>
                        <button>
                            <svg className="bi bi-three-dots" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" clipRule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div className="d-flex justify-content-between mb-1">
                        {/* <span className="font-thai-b font18 c-blue">DGT-PARC<br/>ลานน้ำพุ สยามพารากอน</span>
                        <span className="font-thai-sb font16 c-black">00:00-06:00 / 13.00-18.00</span> */}
                        <span className="font-thai-b font18 c-blue">{m_title}<br/>{data.location_name}</span>
                        <span className="font-thai-sb font16 c-black"></span>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="font-thai-b font16 c-black">
                            
                    {data.team_name != null ? data.team_name : data.emp_name} <span className="c-green">{data.auto_gen_job != 0 ? '(Auto Job gen)':''}</span>
                        </div>
                        <div>
                    <span className="font-thai-b font16 c-black">{data.team_name != null ? data.emp_name : ''}</span>
                            {/* <img src={ChangePath.absoluteUrl("/img/user1.png")} width="20" alt=""/>
                            <img src={ChangePath.absoluteUrl("/img/user1.png")} width="20" alt=""/>
                            <img src={ChangePath.absoluteUrl("/img/user1.png")} width="20" alt=""/>
                            <img src={ChangePath.absoluteUrl("/img/user1.png")} width="20" alt=""/> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardCalendar;







